import Radio from "./radio";
import Group from "./group";
import Button from "./radioButton";
import middleware from "../../middleware";

Radio.Button = middleware(Button, "Radio.Button");
Radio.Group = middleware(Group, "Radio.Group");

export default Radio;



// WEBPACK FOOTER //
// ./_antd1.11.2/radio/index.jsx